<template>
  <div v-if="image">
    <i-img
      :img="image.PathImg"
      @showImg="showBigImg(image)"
      :newImage="image.ImgID == newImageID ? newImage : null"
      class="p-d-flex p-m-auto"
    />
  </div>
  <p-img
    v-if="showImg"
    :imgPath="showImg"
    :openModal="true"
    @return="showImg = null"
    :allImages="allImagesLocal"
  />
</template>

<script>
import { mapState } from "vuex";
import { API_HOST, callProc, apiParam, apiPType } from "@/services/APointAPI";
import { errorReceived } from "@/services/apointUtil";
import PImg from "@/components/partials/p-img";
import { __ } from "@/plugins/i18n/";
export default {
  components: {
    PImg,
  },
  props: {
    image: Object,
    allImages: Array,
    newImage: String,
    newImageID: Number,
  },
  data() {
    return {
      showImg: null,
      allImagesLocal: [],
    };
  },
  mounted() {
    // console.log(this.image, this.allImages);
  },
  methods: {
    deleteImage(event) {
      this.$confirm.require({
        target: event.currentTarget,
        message: __("Are you sure you want to delete the image?"),
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.deleteImageInDB();
        },
        reject: () => {},
      });
    },
    deleteImageInDB() {
      this.$store.dispatch("doLoading", true);
      let procParams = [apiParam("ImgID", this.data.ImgID, apiPType.Int)];
      callProc("WorkerApp_DeleteProblemsPicture", procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log("WorkerApp_DeleteProblemsPicture", result);
          if (result.procReturnValue == 0) {
            this.$emit("reload", "WorkerApp_GetImagesToServiceCall", false);
          } else {
            this.successOrFailedMessage = result.Table[0].desc;
            this.showSuccessOrFailed = true;
            setTimeout(() => {
              this.showSuccessOrFailed = false;
            }, 2000);
          }
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_DeleteProblemsPicture");
        });
    },
    showBigImg(image) {
      this.showImg = image.PathImg;
      this.allImagesLocal = this.allImages.map((img) => {
        return { imgPath: img.PathImg, imgSubject: img.Subject };
      });
    },
  },
  computed: {
    imgSrc() {
      if (this.image.PathImg.startsWith("https://imagedelivery.net/")) return this.image.PathImg;
      return (
        API_HOST +
        "/files/getImg?src=" +
        this.image.PathImg +
        "&sessionToken=" +
        this.sessionToken
      );
    },
    ...mapState({
      sessionToken: (state) => state.api.sessionToken,
    }),
  },
};
</script>

<style scoped>
img {
  width: 100px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>
